/**
 * @file: SummaryModel.js
 * @author: liuye11(liuye11@baidu.com)
 */

import BaseModel from '@baidu/ve-ria/views/BaseModel';

export default class Model extends BaseModel {

    /**
     * @override
     */
    title = '';
}
